import React from "react";
import icons from "../../icons.config"; // Update the path as needed

const FooterDoodles = () => {
  return (
    <div className="bg-tertiary py-[7%] relative bottom-0 overflow-hidden">
      {/* Left Doodle Image in larger screens */}
      <div className="hidden lg:block absolute lg:-left-0 lg:top-0 xl:-left-3 xl:top-5">
        <img src={icons.footerCircles} alt="Doodle Left" className="lg:w-3/5 xl:w-2/3" />
      </div>
      <div className="lg:hidden absolute left-0 top-0">
        <img src={icons.footerCircles} alt="Doodle Left" className="w-1/5 md:w-2/5" />
      </div>
    </div>
  );
};

export default FooterDoodles;
